enum ActionName {
    TRANSPORTATION_STATUS_UPDATE = 'TransportationStatusUpdate',
    TRANSPORTATION_PARCELS_PREVIEW = 'TransportationParcelsPreview'
}

export default ActionName;
